import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { DotsSixVertical, Star, Trash } from "@phosphor-icons/react";
import type { PhotoItem } from "../domain/project";

interface SortablePhotoProps {
  item: PhotoItem;
  index: number;
  url?: string;
  isCover: boolean;
  onChange: (patch: Partial<PhotoItem>) => void;
  onCover: () => void;
  onRemove: () => void;
}

export function SortablePhoto({ item, index, url, isCover, onChange, onCover, onRemove }: SortablePhotoProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: item.id });
  return (
    <article
      ref={setNodeRef}
      className={`photo-row${isDragging ? " is-dragging" : ""}`}
      style={{ transform: CSS.Transform.toString(transform), transition }}
    >
      <button className="drag-handle" type="button" aria-label={`拖动第 ${index + 1} 张照片`} {...attributes} {...listeners}>
        <DotsSixVertical size={21} weight="bold" />
      </button>
      <div className="photo-thumb">
        {url ? <img src={url} alt="" /> : <div className="image-skeleton" />}
        <span>{String(index + 1).padStart(2, "0")}</span>
      </div>
      <div className="photo-fields">
        <label>
          <span>标题</span>
          <input value={item.title} onChange={(event) => onChange({ title: event.target.value })} />
        </label>
        <label>
          <span>说明</span>
          <textarea value={item.caption} rows={2} placeholder="写下一句当时的记忆" onChange={(event) => onChange({ caption: event.target.value })} />
        </label>
      </div>
      <div className="photo-actions">
        <button type="button" className={isCover ? "icon-button is-active" : "icon-button"} title="设为封面" aria-label="设为封面" onClick={onCover}>
          <Star size={18} weight={isCover ? "fill" : "regular"} />
        </button>
        <button type="button" className="icon-button danger" title="移除照片" aria-label="移除照片" onClick={onRemove}>
          <Trash size={18} />
        </button>
      </div>
    </article>
  );
}
